import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import {JobEntry} from 'src/views/admin/ScheduledJobs/types';
import React, {MouseEventHandler} from 'react';
import Button from 'src/components/button';
import req from 'shared/req';

const FinishJob: ColumnSettings<JobEntry>['renderValue'] = (_, jobEntry) => {
  const finishJob: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.stopPropagation();
    await req({
      url: `/v1/job-entries/${jobEntry.id}/finish`,
      method: 'post',
    });
  };

  if (jobEntry.isRunning) {
    return (
      <Button outline size="small" onClick={finishJob}>
        Finish
      </Button>
    );
  }

  return null;
};

export default FinishJob;
